module.exports = __webpack_public_path__ + "static/media/okticon.db287231.woff";